import { useQuery } from '@tanstack/react-query';

import { getAtolCertificatesByCustomerId } from '~/services/TravelComplianceService';

import { atolCertificateQueryKeys } from './atolCertificateQueryKeys';

export function useGetAtolCertificatesByCustomer(customerId: string, enabled = true) {
  return useQuery({
    queryKey: atolCertificateQueryKeys.byCustomer(customerId),
    queryFn: async () => {
      const response = await getAtolCertificatesByCustomerId(customerId);
      return response.result;
    },
    enabled: !!customerId && enabled,
  });
}
